/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Stopwatch = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 20 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M17.2 7.8l.6-.6.6.6c.1.1.3.2.5.2s.3-.1.5-.2c.3-.3.3-.7 0-.9l-2.1-2c-.3-.3-.7-.3-.9 0-.3.3-.3.7 0 .9l.6.6-.6.6c-1.1-.9-2.3-1.6-3.7-2V4h.5c.4 0 .7-.3.6-.7V.5c0-.4-.3-.7-.6-.7H6.9c-.4 0-.6.3-.6.7v2.9c0 .4.3.6.6.6h.5v.8C6 5.2 4.8 5.9 3.7 6.9l-.6-.6.6-.6c.3-.3.3-.7 0-.9-.3-.3-.7-.3-1 0l-2.1 2c-.3.3-.3.7 0 .9.2.2.4.2.6.2s.3-.1.5-.2l.6-.6.6.6C1.4 9.4.5 11.6.5 14c0 5.3 4.3 9.6 9.6 9.6s9.6-4.3 9.6-9.6c-.1-2.3-1-4.5-2.5-6.2zM7.6 1.1h4.8v1.6H7.6V1.1zM8.7 4h2.6v.5c-.4-.1-.9-.1-1.3-.1s-.9 0-1.3.1V4zM10 22.4c-4.6 0-8.3-3.7-8.3-8.3S5.4 5.8 10 5.8s8.3 3.7 8.3 8.3c0 4.5-3.7 8.3-8.3 8.3z" /><path d="M13.6 8.2c-.3-.2-.7-.1-.9.3l-2.3 4.3c-.4 0-.8.2-1 .6-.4.6-.2 1.3.4 1.7.6.3 1.4.1 1.7-.5.2-.4.2-.9 0-1.2l2.3-4.3c.2-.3.1-.7-.2-.9z" />
      </g>
    </svg>
  </span>
);

Stopwatch.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Stopwatch.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Stopwatch;
